var _polygon, _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.6 24.6",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Information Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "illustrationsAccent1",
    points: "17 0.9 8.5 3 3.2 8.7 3.2 16.9 8.5 22.1 17.6 23.5 17 24 7.8 24 0.9 16.9 0.9 7.7 7.3 0.9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "illustrationsPrimary",
    cx: 12.4,
    cy: 18.2,
    r: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "m12.8 5.2c0.5 0 0.9 0.4 0.9 0.9l-0.3 9c0 0.5-0.4 0.9-0.9 0.9h-0.3c-0.5 0-0.9-0.4-0.9-0.9l-0.4-9c0-0.5 0.4-0.9 0.9-0.9h1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "illustrationsPrimary",
    d: "m16.9 1.2 6.5 6.5v9.2l-6.5 6.5h-9.2l-6.5-6.5v-9.2l6.5-6.5h9.2m0.5-1.2h-10.2l-7.2 7.2v10.2l7.2 7.2h10.2l7.2-7.2v-10.2l-7.2-7.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation_circle.bf7349f70588398bf40aeccc0039afec.svg";
export { ForwardRef as ReactComponent };